import * as actions from "./actions";
import produce from "immer";

const initialState = {
  isOnlyStreaming: false,
  onlyStreamingCenterCostId: null,
};

export const reducer = produce((state, action) => {
  switch (action.type) {
    case actions.SETONLYSTREAMING:
      state.isOnlyStreaming = action.payload.isOnlyStreaming;
      state.onlyStreamingCenterCostId =
        action.payload.onlyStreamingCenterCostId || null;
      break;
    default:
      break;
  }
}, initialState);
